import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"

import ModernModal from "shared/components/ModernModal/index"
import Typograph from "components/Typograph"

import styles from "./styles.css"

const InterruptModal = ({ t, isOpen, onClose, onInterruptSchedule }) => {
  return (
    <ModernModal
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={onInterruptSchedule}
      confirmButtonText={t("CONFIRM")}
      cancelButtonText={t("MSG_0056")}
    >
      <Typograph htmlTag="h2" preset="h2" color="outer_space">
        {t("MSG_0064")}
      </Typograph>
      <Typograph
        htmlTag="p"
        size="medium"
        weight="regular"
        color="outer_space"
        classNames={styles.confirmText}
        dangerouslySetInnerHTML={{ __html: t("CONFIRM_INTERRUPT_SCHEDULE") }}
      />
      <Typograph htmlTag="p" size="medium" weight="bold" color="nevada_gray">
        {t("ALERT_INTERRUPT")}
      </Typograph>
    </ModernModal>
  )
}

InterruptModal.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onInterruptSchedule: PropTypes.func
}

const enhance = compose(translate())

export default enhance(InterruptModal)



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/InterruptScheduleModal/index.js